import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { Toaster } from './components/ui/sonner';
import Layout from './components/Layout';
import LoginPage from './pages/LoginPage';
import Dashboard from './pages/Dashboard';
import SuperAdminDashboard from './pages/SuperAdminDashboard';
import POSPage from './pages/POSPage';
import ProductsPage from './pages/ProductsPage';
import InventoryPage from './pages/InventoryPage';
import CustomersPage from './pages/CustomersPage';
import SuppliersPage from './pages/SuppliersPage';
import PurchasesPage from './pages/PurchasesPage';
import SalesPage from './pages/SalesPage';
import SettingsPage from './pages/SettingsPage';
import AIPredictionsPage from './pages/AIPredictionsPage';
import CompaniesPage from './pages/CompaniesPage';
import AccountsReceivablePage from './pages/AccountsReceivablePage';
import ReportsPage from './pages/ReportsPage';
import RolesPermissionsPage from './pages/RolesPermissionsPage';
import UsersPage from './pages/UsersPage';
import CategoriesPage from './pages/CategoriesPage';
import UnitsPage from './pages/UnitsPage';
import WarehousesPage from './pages/WarehousesPage';
import PromotionsPage from './pages/PromotionsPage';
import ConstructionDashboard from './pages/ConstructionDashboard';
import ProjectsPage from './pages/ProjectsPage';
import SolicitudesMaterialesPage from './pages/SolicitudesMaterialesPage';
import SubcontractsPage from './pages/SubcontractsPage';
import MachineryPage from './pages/MachineryPage';
import ProjectDetailsPage from './pages/ProjectDetailsPage';
import WastagePage from './pages/WastagePage';
import SuperAdminActivityPage from './pages/SuperAdminActivityPage';
import './App.css';

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-muted-foreground">Cargando...</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
}

function AppRoutes() {
  const { user } = useAuth();

  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <LoginPage />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="super-dashboard" element={<SuperAdminDashboard />} />
        <Route path="super-admin-activity" element={<SuperAdminActivityPage />} />
        <Route path="pos" element={<POSPage />} />
        <Route path="products" element={<ProductsPage />} />
        <Route path="inventory" element={<InventoryPage />} />
        <Route path="ai-predictions" element={<AIPredictionsPage />} />
        <Route path="customers" element={<CustomersPage />} />
        <Route path="accounts-receivable" element={<AccountsReceivablePage />} />
        <Route path="suppliers" element={<SuppliersPage />} />
        <Route path="purchases" element={<PurchasesPage />} />
        <Route path="sales" element={<SalesPage />} />
        <Route path="companies" element={<CompaniesPage />} />
        <Route path="reports" element={<ReportsPage />} />
        <Route path="roles-permissions" element={<RolesPermissionsPage />} />
        <Route path="users" element={<UsersPage />} />
        <Route path="categories" element={<CategoriesPage />} />
        <Route path="units" element={<UnitsPage />} />
        <Route path="warehouses" element={<WarehousesPage />} />
        <Route path="promotions" element={<PromotionsPage />} />
        <Route path="wastage" element={<WastagePage />} />
        <Route path="construction" element={<ConstructionDashboard />} />
        <Route path="projects" element={<ProjectsPage />} />
        <Route path="projects/:id" element={<ProjectDetailsPage />} />
        <Route path="requisitions" element={<SolicitudesMaterialesPage />} />
        <Route path="subcontracts" element={<SubcontractsPage />} />
        <Route path="machinery" element={<MachineryPage />} />
        <Route path="settings" element={<SettingsPage />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
          <Toaster position="top-right" />
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
